import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { UserContextType } from '../../../user/user.types';
import { useRestrictedModal } from '../../modal/useRestrictedModal';
import { TextButton } from '../../button';

type Props = {
  accessPremium: UserContextType['accessPremium'];
  source: string;
  sendAnalytics: () => void;
};

export const PrintActionButton: FC<Props> = ({
  accessPremium,
  sendAnalytics,
  source,
}) => {
  const { openRestrictedModal } = useRestrictedModal();
  const printLawyerPage = () => {
    if (!accessPremium)
      return openRestrictedModal({ source: `${source}_print` });
    sendAnalytics();
    window.print();
  };

  return (
    <TextButton onClick={printLawyerPage} iconLeft="print">
      <FormattedMessage id="components/sub-header/actions/PrintActionButton.tsx/1" />
    </TextButton>
  );
};
